import { initListeners } from './input_events'
import autocomplete from './autocomplete'

const formValidator = () => {
  /**
   * Constants
   */

  // HTMLElements
  const form = document.querySelector('.form'),
      submitBtn = form.querySelector('button[type="submit"]'),
      civBtns = [].slice.call(form.querySelectorAll('.btn--civility')),
      licenceBtns = [].slice.call(form.querySelectorAll('.btn--licence')),
      recallBtns = [].slice.call(form.querySelectorAll('.btn--recall')),
      helpers = [].slice.call(form.querySelectorAll('.form__helper'))

  /**
   * Variables
   */

  let inputArray = [].slice.call(form.querySelectorAll('.form__input'))

  /**
   * Calls
   */
    helpers.forEach(helper => {
        helper.addEventListener('click', e => {
            if (helper.parentElement.classList.contains('error')) {
            let currentInput = document.querySelector(
                `.form__input--${helper.getAttribute('data-input')}`
            )
            currentInput.value = ''
            }
        })
    })

  inputArray.forEach(input => {
    if (input.type === 'radio') {
      if (input.name === 'licence') {
        initListeners().setRadioChange(input, form, licenceBtns)
      } else if (input.name === 'recall') {
        initListeners().setRadioChange(input, form, recallBtns)
      } else {
        initListeners().setRadioChange(input, form, civBtns)
      }

    } else if (
      input.type !== 'radio' &&
      input.type !== 'checkbox' &&
      input.id !== 'new_zipcode' &&
      input.classList.contains('required')
    ) {
      initListeners().setFocus(input, true)
      if (input.id == 'phone') {
        initListeners().setKeypress(input)
      }
    } else if (input.id == 'phone' && !input.classList.contains('required')) {
      initListeners().setFocus(input, false)
      initListeners().setKeypress(input)
    } else {
      initListeners().setFocus(input, false)
    }
  })

  // console.log(form)
  // Note : le formulaire ne contient pas de classes

  // if (form.classList.contains("form__centered") || form.classList.contains("form__rfc") || form.classList.contains("form__rfc-franchise")) {
    // let civSelect = document.querySelector(".select-civility")

    let selectList = document.querySelectorAll('.select-object')
    if (selectList) {
      selectList.forEach(select => {
        initListeners().setSelectChange(select)
      })
    }
    // initListeners().setSelectChange(civSelect)
  // }

  initListeners().setSubmit(submitBtn, inputArray, form)
}

export default formValidator
